// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"a584cfb4","251":"e5b8ad09","407":"7e2cec9e","453":"b53fa46a","509":"163d2d3c","534":"ceaef050","653":"b352c55d","717":"f80f0b37","723":"6dd32b78","777":"13c573ee","946":"1531afd0"}[chunkId] + ".chunk.js";
};